import styled from 'styled-components';
import { DealerCommentStyled } from '../DealerCommentStyled';

export const DealerCommentStyledDS = styled(DealerCommentStyled)`
    
`;
